import { applySnapshot, getSnapshot, types } from "mobx-state-tree";

export let defaultPersonalInfo = {
  firstName: "",
  lastName: "",
  email: "",
  gender: "male",
  dateOfBirth: "",
  phone: "",
  whatsappNumber: "",
  country: "Nigeria",
  subscription: true,
  primaryLanguage: "English",
  medium: "",
  address: "",
  nationality: "Nigeria",
  state: "",
  region: "",
  vicinity: "",
};
export type SPersonalInfoType = {
  firstName: string;
  lastName: string;
  email: string;
  gender: string;
  subscription: boolean;
  nationality: string;
  dateOfBirth: string;
  phone: string;
  whatsappNumber: string;
  // primaryLanguage: string;
  medium: string;
  alternateNo: string;
};

export const PersonalInfoStore = types
  .model("PersonalInfoStore", {
    firstName: types.optional(types.maybeNull(types.string), ""),
    lastName: types.optional(types.maybeNull(types.string), ""),
    email: types.optional(types.maybeNull(types.string), ""),
    gender: types.optional(types.string, "male"),
    dateOfBirth: types.optional(types.maybeNull(types.string), ""),
    phone: types.optional(types.maybeNull(types.string), ""),
    whatsappNumber: types.optional(types.maybeNull(types.string), ""),
    subscription: types.optional(types.boolean, true),
    primaryLanguage: types.optional(types.maybeNull(types.string), ""),
    medium: types.optional(types.maybeNull(types.string), ""),
    alternateNo: types.optional(types.maybeNull(types.string), ""),
    nationality: types.optional(types.maybeNull(types.string), "Nigeria"),
    country_code: types.optional(types.string, "NG"),
  })
  .views((self) => {
    return {
      get formValues(): SPersonalInfoType {
        let defaultInfo = {
          firstName: self.firstName === null ? "" : self.firstName,
          lastName: self.lastName === null ? "" : self.lastName,
          email: self.email === null ? "" : self.email,
          gender: self.gender,
          subscription: self.subscription,
          dateOfBirth: self.dateOfBirth === null ? "" : self.dateOfBirth,
          phone: self.phone === null ? "" : self.phone,
          whatsappNumber:
            self.whatsappNumber === null ? "" : self.whatsappNumber,
          // primaryLanguage:
          //   self.primaryLanguage === null ? "" : self.primaryLanguage,
          medium: self.medium === null ? "" : self.medium,
          alternateNo: self.alternateNo === null ? "" : self.alternateNo,
          nationality: self.nationality === null ? "" : self.nationality,
        };
        // let result: any = getSnapshot(self);
        return defaultInfo;
      },
      get completed() {
        return Boolean(
          self.firstName &&
            self.lastName &&
            self.nationality &&
            self.email &&
            self.gender &&
            // self.subscription &&
            self.dateOfBirth &&
            self.phone &&
            self.whatsappNumber &&
            //  ||
            self.nationality,
          // self.primaryLanguage
          // self.medium
        );
      },
    };
  })
  .actions((self: any) => {
    const onFormSubmit = function onFormSubmit(formData: any) {
      let xx: any = getSnapshot(self);
      applySnapshot(self, { ...xx, ...formData });
    };

    return {
      onFormSubmit,
      // setSupportedCountryAccount(country) {
      //   self.supportedCountryAccount = country;
      // },
    };
  });
